import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TechMarquee from "@/components/TechMarquee";
import About from "@/components/About";
import ProfileFocus from "@/components/ProfileFocus";
import Expertise from "@/components/Expertise";
import Achievement from "@/components/Achievement";
import Blog from "@/components/Blog";
import Freelance from "@/components/Freelance";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Admin from "@/pages/Admin";
import ArticleEditor from "@/pages/ArticleEditor";
import BlogDetail from "@/pages/BlogDetail";
import { Toaster } from "@/components/ui/sonner";
import { useSeo } from "@/lib/useSeo";

const Home = () => {
  useSeo({
    title: "Joneten Saputra — Product Manager & Technical Solution Specialist",
    description:
      "Product Manager & Technical Solution Specialist berpengalaman sejak 2012 dalam AI, IoT, software, hardware, smart energy, dan manajemen produk digital.",
    type: "website",
    keywords: ["Joneten Saputra", "Product Manager", "Technical Solution", "AI", "IoT", "Smart Energy", "Palembang Digital"],
  });
  return (
    <div className="relative min-h-screen bg-[#060a1a] text-slate-200 overflow-x-hidden" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <TechMarquee />
        <About />
        <ProfileFocus />
        <Expertise />
        <Achievement />
        <Blog />
        <Freelance />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

/**
 * Top-level router that:
 * - Intercepts Emergent OAuth callback (URL hash contains session_id=...)
 *   BEFORE normal routes run, to prevent race conditions.
 */
const AppRouter = () => {
  const location = useLocation();
  // Detect session_id during render (NOT in useEffect) — synchronous to avoid race with AuthProvider.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/blog/:slug" element={<BlogDetail />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <Admin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/articles/new"
        element={
          <ProtectedRoute>
            <ArticleEditor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/articles/edit/:id"
        element={
          <ProtectedRoute>
            <ArticleEditor />
          </ProtectedRoute>
        }
      />
      {/* fallback */}
      <Route path="*" element={<Home />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="bottom-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
